import React, { useEffect, useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import { parseClasses, cleanFieldProps } from '../../lib/ep.js';

import ToggleButton from './ToggleButton';

import Loadable from 'react-loadable';
import FieldWrapper from './FieldWrapper.js';
import ButtonCollection from './ButtonCollection.js';

const EmojiPicker = Loadable({
	loader:() => import('./EmojiPicker'),
	loading:() => (
		<div>Loading...</div>
	),
});

const Input = (props) => {
	const name = props?.name ?? false;
	
	const refs = useRef({});

	const [ display_password, setDisplayPassword ] = useState(false);
	const [ chars_left, setCharsLeft ] = useState(false);
	const [ has_many_chars, setHasManyChars ] = useState(false);
	const [ value, setValue ] = useState(props?.value ?? ((props.model != undefined && props.model[name] != null) ? props.model[name] : ''));

	const enable_autocomplete = props?.autocomplete ?? false;
	const only_input = props?.only_input ?? false;
	const max_length = props?.max_length ?? null;
	const exclude_from_count = props?.exclude_from_count ?? [];
	const limit_max_length = props?.limit_max_length ?? true;
	const is_fake = props?.is_fake ?? false;
	const has_emojis = props?.has_emojis ?? false;
	const autoselect = props?.autoselect ?? false;
	const hidden = props?._hidden ?? false;
	const disabled = props?.disabled ?? false;
	const _placeholder = props?.placeholder ?? false;
	const after_message_tmp = props?.after_message_tmp ?? null;
	const autotranslate_placeholder = props?.autotranslate_placeholder ?? true;
	const placeholder = (_placeholder !== false) ? ((autotranslate_placeholder) ? props.intl.formatMessage({id:_placeholder}) : _placeholder) : null;
	let type = props?._type ?? 'text';

	let min = null;
	let max = null;
	let autocomplete_value = 'off';

	const type_initial = type
	switch(type) {
		case 'number':
			min = props?.min ?? null;
			max = props?.max ?? null;
			break;

		case 'password':
			if(display_password) type = 'text';
			if(!enable_autocomplete) autocomplete_value = 'new-password';
			break;

		default:
			if(hidden) type = 'hidden';
			break;
	}

	const inputRef = (_ref) => {
		refs.current['element'] = _ref;
		if(props.inputRef !== undefined) props.inputRef(_ref);
	};

	const calcExcludedCharsFromCount = (value) => {
		let total = 0;
		if(value == "" || value == undefined) return total;

		if(exclude_from_count.length > 0) {
			exclude_from_count.map((char) => {
				total += value.split(char).length - 1;
			});
		}

		return total;
	};

	const calcCharsLeft = (value, max_length) => {
		if(value == "" || value == undefined) return max_length;

		let field_value = value;
		if(exclude_from_count.length > 0) {
			exclude_from_count.map((char) => {
				field_value = field_value.split(char).join("");
			});
		}

		return max_length - field_value.length;
	};

	const updateCharCounter = (value, max_length) => {
		const chars_left = calcCharsLeft(value, max_length);
		setHasManyChars((chars_left < 0) ? true : false);
		setCharsLeft(chars_left);
	};

	const change = (e, max_length) => {
		var forced_value = e.target.value;
		switch(type) {
			case 'number':
				if(min != undefined && parseInt(forced_value) < min && forced_value != '') forced_value = min;
				if(max != undefined && parseInt(forced_value) > max) forced_value = max;
				break;
		}

		setValue(forced_value);
		if(max_length) typeText(e, max_length);
		if(props.change !== undefined) props.change(name, forced_value);
	};

	const typeText = (e, max_length) => {
		if(e.charCode == 13 && props.onEnter != undefined) props.onEnter();

		if(!max_length) return;
		updateCharCounter(e.target.value, max_length);
	};

	const upHandler = ({key}) => {
		if(props?.onKeyAction?.action != undefined) {
			if(props.onKeyAction.key == key || props.onKeyAction.key == 'all') {
				props.onKeyAction.action();
			}
		}
	};

	const concatText = (new_text) => {
		let box = $(refs.current['element']);
		let position_focus = box.prop("selectionStart");
		let position_start = 0;
		let position_end = box.val().length;
		let text = box.val();
		text = text.substr(position_start, position_focus) + new_text + text.substr(position_focus, position_end);

		change({ target:{ value:text } }, props.max_length);
	};

	useEffect(() => {
		const _value = props?.value ?? (props?.model?.[name] ?? '');
		setValue(_value);

		if(max_length) updateCharCounter(_value, max_length);
	}, [ props.value, props.model ]);

	if(name === false) return null;

	let field_class = ['common_form_item'];
	if(disabled) field_class.push('disabledField disabledItem');

	let has_max_length = null;
	if(limit_max_length && max_length) {
		const exclude_chars = calcExcludedCharsFromCount(value);

		has_max_length = parseInt(max_length);
		has_max_length += exclude_chars;
	}

	let generic_input_props = {
		id:props?.id ?? name,
		name,
		value,
		min,
		max,
		lang:props.lang,
		placeholder,
		after_message_tmp,
		dir:props?.dir ?? 'auto',
		autoComplete:(enable_autocomplete) ? null : autocomplete_value,
		maxLength:has_max_length,
		disabled:(disabled) ? true : null,
		id:props.id,
		style:props.style,
		title:props.title,
		tabIndex:(is_fake) ? -1 : null,
		onKeyDown:upHandler,
		autoFocus:props?.autofocus ?? false,
		onKeyPress:(e) => typeText(e, max_length),
		onChange:(e) => change(e, max_length),
		onFocus:(autoselect) ? () => { refs.current['element'].select(); } : null,	//If the field is auto select just select the text on focus
		onBlur:props.onBlur,
	};
	
	if(only_input) {
		let classname = props?.classname ?? 'input text';
		classname = parseClasses(classname, props._class, 'input');
		if(type == 'password') classname += ' password';
		if(hidden) classname += ' hidden in_top';
		if(max_length) classname += ' with_charcounter';
		if(has_emojis) classname += ' with_emoji';

		return (
			<input
				ref={inputRef}
				class={`${classname} ${field_class}`}
				type={type_initial}
				{...generic_input_props}
			/>
		)
	}

	const wrapper_props = cleanFieldProps(props);
	if(has_max_length !== false) wrapper_props.display_error_at_bottom = true;

	const actions = props?.actions ?? false;
	if(actions !== false || type_initial == 'password') {
		if(wrapper_props._class == undefined) wrapper_props._class = {};
		if(wrapper_props._class.other == undefined) wrapper_props._class.other = '';

		const input_size = wrapper_props._class?.input_size ?? 'small';
		if(wrapper_props._class.other.indexOf('input_with_button') < 0) wrapper_props._class.other += ` input_with_button is_${input_size}`;
	}

	let paddingInlineEnd = 0;
	if(max_length) paddingInlineEnd++;
	if(has_emojis) paddingInlineEnd++;
	if(actions) paddingInlineEnd++;
	const style = (paddingInlineEnd > 0) ? { paddingInlineEnd:`calc(${paddingInlineEnd} * (var(--squared-button-size) + 0.4em))` } : null;
	
	let has_actions = false;
	if(max_length) has_actions = true;
	if(has_emojis) has_actions = true;
	if(actions !== false) has_actions = true;
	if(type_initial == 'password') has_actions = true;

	return (
		<FieldWrapper type='text' {...wrapper_props}>
			{(props.custom_input_contents != undefined) && (
				<span class="extra_input">{props.custom_input_contents}</span>
			)}

			<input
				ref={inputRef}
				{...generic_input_props}
				class={field_class.join(" ")}
				type={type}
				style={style}
			/>

			{(has_actions) && (
				<ButtonCollection _class={{ other:'input_actions' }}>
					{(max_length) && (
						<div class="gui_charcounter_c in_top">
							<div class={'is_monospaced gui_charcounter' + ((has_many_chars) ? ' redBg' : '')}>
								{(chars_left !== false) ? chars_left : max_length}
							</div>
						</div>
					)}

					{(has_emojis) && (
						<EmojiPicker
							ref={(_ref) => { refs.current['emojipicker'] = _ref; }}
							onEmojiPick={concatText}
						/>
					)}

					{(actions !== false) && (
						actions
					)}

					{(type_initial == 'password') && (
						<ToggleButton
							squared={true}
							active={(!display_password) ? true : false}
							color='black'
							icon='knk-visible'
							icon_off='knk-invisible'
							_class={{other:'_toggle_passw_visibility not_bordered_button'}}
							onClick={() => setDisplayPassword(!display_password)}
						/>
					)}
				</ButtonCollection>
			)}
		</FieldWrapper>
	);
}

export default injectIntl(Input);